/*
 * @Author: zl
 * @Date: 2022-03-29 11:39:34
 * @LastEditTime: 2022-03-29 15:03:30
 * @LastEditors: zl
 * @Description: 基础资料
 */
import request from '@/api/request'

export const selProjectBasicPageList = function (data) {
    return request({
        url: 'busProject/selProjectBasicPageList',
        method: 'post',
        data,
    })
}

/**
* 描述： 审计资料--左侧菜单获取
* 接口管理员：崔北超
* 参数：
{
}
*/
export const getTaskFileListByProject = function (data) {
    return request({
        url: '/busAuditFile/getTaskFileListByProject',
        method: 'post',
        data,
    })
}

/**
* 描述： 委托报审资料回显
* 接口管理员：崔北超
* 参数：
{
}
*/
export const getFiles = function (data) {
    return request({
        url: '/busAuditFile/getFiles',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
* 描述： 三方巡查资料--左侧菜单获取
* 接口管理员：俞祥东
*/
export const getTripartiteInspectionTreeInfo = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/getTripartiteInspectionTreeInfo',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 基础资料
 * 获取季度数据
 */
export const getQuarterData = function (data) {
    return request({
        url: 'busProject/getQuarterData',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 其他资料 左侧数据
 */
export const getPackTree = function (data) {
    return request({
        url: '/busAuditFile/getPackTree',
        method: 'post',
        data
    })
}

/**
 * 其他资料 右侧数据
 */
export const getOtherFiles = function (data) {
    return request({
        url: '/busAuditFile/getOtherFiles',
        method: 'post',
        data
    })
}